import React from 'react'
import PropTypes from "prop-types"
import { ButtonToolbar, ToggleButton, ToggleButtonGroup } from 'react-bootstrap'

import SchedulesEditor from './SchedulesEditor'
import ExceptionsEditor from './ExceptionsEditor'
import { timetablePropType } from '../timetable'
import HoverTip from '../../components/HoverTip'

import "./timetableEditor.less"

class TimeTableEditor extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      // #TODO there are a lot of state variables you are not initializing here but using anyway
      title: props.value && props.value.title,
      chTitle: props.value && props.value.chTitle,
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className="timetable-editor">
          {
            this.props.includeTypeSwitch && (
              <ButtonToolbar style={{ marginBottom: 10 }}>
                <ToggleButtonGroup type="radio" name="options"
                  value={!this.props.timetable.allDay ? 1 : 2}
                  onChange={v => {
                    if (v == 1) {
                      this.props.onChange({ ...this.props.timetable, allDay: false })
                    }
                    else if (v == 2) {
                      this.props.onChange({ ...this.props.timetable, allDay: true })
                    }
                    else alert("Error WTF-101291-b")
                  }}
                >
                  {
                    [
                      {
                        v: 1, 
                        text: "🎟️ Horario con turnos",
                        help: "Se debe elegir uno entre varios turnos al día" 
                      },
                      { 
                        v: 2, 
                        text: "🕓 Horario \"libre\"", 
                        help: "Se puede ir en cualquier momento dentro de un rango cada día" 
                      },
                    ].map(({ v, text, help }) => (
                      <ToggleButton key={v} value={v}>
                        <HoverTip key={v} text={help}>
                          <span>{text}</span>
                        </HoverTip>
                      </ToggleButton>
                    ))
                  }
                </ToggleButtonGroup>
              </ButtonToolbar>
            )
          }

          <SchedulesEditor
            timetable={this.props.timetable}
            onChange={change => this.props.onChange(change)}
          />

          <ExceptionsEditor
            timetable={this.props.timetable}
            onChange={change => this.props.onChange(change)}
          />

        </div>
      </React.Fragment>
    )
  }
}

TimeTableEditor.propTypes = {
  timetable: timetablePropType.isRequired,
  onChange: PropTypes.func.isRequired,
  
  includeTypeSwitch: PropTypes.bool
}

TimeTableEditor.defaultProps = {
  includeTypeSwitch: true
}

export default TimeTableEditor